import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import Programs from "@/lib/studyPlan";
import Style from "@/lib/style";

type Props = {
  programName: string;
};

export default function StudyPlan(props: Props) {
  let { programName } = props;
  const matchedStyle = Style.find(s => s.title === programName);
  const program = Programs.find(p => p.title === programName);

  return (
    <div className="bigscreen-responsive max-w-xs py-14 px-12 m-0 md:pl-[500px] md:px-16">
      <span className={`${matchedStyle?.colors?.[0].textColor} font-bold`}>Explorá nuestro</span>
      <h1 className="font-bold text-2xl mb-4 md:text-3xl">Plan de estudios</h1>
      <p className="font-thin text-xs py-2 md:text-lg"> Enfocado en estimular el camino hacia el desarrollo personal y profesional, permitiendo potencializar al máximo el espíritu emprendedor. </p>
      {program?.quarters.map((quarter) => (
        <div key={quarter.quarter}>
          <div className="flex py-6 m-auto gap-8">
            <div className={`${matchedStyle?.colors?.[0].textColor} font-bold text-4xl w-8 md:text-7xl`}> {quarter.quarter} </div>
            <ul className="ml-3 font-bold text-[10px] md:text-lg">
              {quarter.courses.map((course) => (
                <li key={course.code} className="flex gap-4 font-normal ml-1 text-[10px] md:text-lg md:m-auto"> <span className="font-bold xl:w-20">{ course.code }</span> <span className="xl:w-[500px]">{ course.name }</span></li>
              ))}
            </ul>
          </div>
        </div>
      ))}
      <div className={`${matchedStyle?.colors?.[0].colorSection} bg-opacity-5 p-10 rounded-xl font-thin text-sm md:text-lg`}>
        <p className={`sm:text-lg py-2 md:text-2xl font-bold ${matchedStyle?.colors?.[0].textColor}`}>Crecimiento académico y práctico</p>
        <p className="font-thin text-xs py-2 md:text-lg">En Amura, cada clase de cocina es una oportunidad para crecer. Nuestros estudiantes de gastronomía podrán experimentar el participar de: </p>
        <ul className="my-3 ml-4 xl:my-5 list-disc">
          <li className="font-bold text-md xl:text-lg">Talleres con chefs invitados de renombre internacional</li>
          <li className="font-bold text-md xl:text-lg">Prácticas en restaurantes y hoteles asociados</li>
          <li className="font-bold text-md xl:text-lg">Competencias culinarias internas y externas</li>
          <li className="font-bold text-md xl:text-lg">Proyectos de investigación gastronómica</li>
        </ul>
      </div>
      <div className={`flex flex-col gap-y-2 items-center text-center font-thin text-sm py-12 w-full mt-8 border-t ${matchedStyle?.colors?.[0].border} md:text-lg`}>
        <p className="px-4">¿Estás listo para llevar tu pasión culinaria al siguiente nivel y<br/> convertirte en un líder en la gastronomía?</p>
        <p className={`px-4 font-bold ${matchedStyle?.colors?.[0].textColor} `}>¡Conversemos y descubrí cómo Amura puede impulsar tu<br/> carrera hacia la excelencia culinaria!</p>
        <Link href="https://wa.me/50662236864" target="_blank" className="flex justify-center items-center rounded-full my-8 py-2 px-4 shadow-sm bg-white border-2 border-[#46EB61] font-bold text-sm hover:shadow-lg md:py-3 md:px-5">
          <FontAwesomeIcon icon={faWhatsapp} className="text-xl mr-3 text-[#46EB61]" />
          Conversemos
        </Link>
      </div>
    </div>
  );
}

